import PropTypes from 'prop-types';
import get from 'lodash/get';
import { formatLocation } from '../../utils/location-utils';

export const contactShape = PropTypes.shape({
  id: PropTypes.string,
  name: PropTypes.string,
  notes: PropTypes.string,
  general: PropTypes.shape({
    field_hs_na_nces_id: PropTypes.string,
  }),
  address: PropTypes.shape({
    field_hs_elna_address_line1: PropTypes.string,
    field_hs_elna_city: PropTypes.string,
    field_hs_elna_state_latest: PropTypes.string,
    field_hs_eln_zip: PropTypes.string,
  }),
  naviance: PropTypes.shape({
    field_hs_na_nguid: PropTypes.string,
    field_hs_na_nid: PropTypes.string,
    field_hs_elna_phone: PropTypes.string,
  }),
  repVisitsAccount: PropTypes.shape({
    primaryContact: PropTypes.shape({
      mail: PropTypes.string,
      field_first_name: PropTypes.string,
      field_last_name: PropTypes.string,
      field_full_name: PropTypes.string,
      field_job_position: PropTypes.string,
      field_profile_picture_file_url: PropTypes.string,
    }),
  }),
});

export function getInitials(firstName, lastName) {
  let result = '';
  if (firstName && firstName.length > 0) {
    result += firstName[0];
  }
  if (lastName && lastName.length > 0) {
    result += lastName[0];
  }
  return result.toUpperCase();
}

export function getAddress(address) {
  const street = get(address, 'field_hs_elna_address_line1') || '';
  const city = get(address, 'field_hs_elna_city') || '';
  const state = get(address, 'field_hs_elna_state_latest') || '';
  const zip = get(address, 'field_hs_eln_zip') || '';
  const cityState = formatLocation(city, state);
  let addr = `${street} ${cityState} ${zip}`;
  addr = addr.trim();
  return addr;
}

export function getContactDetails(contact) {
  const primaryContact = get(contact, 'highSchool.repVisitsAccount.primaryContact') || {};
  const phone = get(contact, 'highSchool.naviance.field_hs_elna_phone') || '';
  const notes = get(contact, 'notes') || '';
  const firstName = get(primaryContact, 'field_first_name') || '';
  const lastName = get(primaryContact, 'field_last_name') || '';
  const fullName = get(primaryContact, 'field_full_name') || '';
  const position = get(primaryContact, 'field_job_position') || '';
  const avatar = get(primaryContact, 'field_profile_picture_file_url') || '';
  const mail = get(primaryContact, 'mail') || '';
  const address = getAddress(contact.highSchool.address);
  const initials = getInitials(firstName, lastName);
  const schoolName = get(contact, 'highSchool.name') || '';
  return {
    firstName,
    lastName,
    fullName,
    initials,
    position,
    avatar,
    mail,
    phone,
    notes,
    address,
    schoolName,
  };
}
